package fr.frux.feature.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique de l'[AuthViewModel], honoré par le composition root (#43). */
fun interface AuthViewModelFactory {
    fun create(): AuthViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalAuthViewModelFactory = staticCompositionLocalOf<AuthViewModelFactory> {
    error("AuthViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
}

/** Fabrique l'AuthViewModel depuis la fabrique fournie par le root (cf. #107). */
@Composable
fun rememberAuthViewModel(): AuthViewModel {
    val factory = LocalAuthViewModelFactory.current
    return viewModel { factory.create() }
}
